import type { RequestParams, RequestCallbacks, StartRequestAction } from "EntitiesApi/Actions";
import type { Account } from "Utils/types";

export const RECEIVE_ACCOUNT_SETTING_DATA = "user_settings/RECEIVE_ACCOUNT_SETTINGS_DATA";
export const START_REQUEST = "user_setting/START_REQUEST";

export const receiveAccountSettingData = (response: Account) => ({
  type: RECEIVE_ACCOUNT_SETTING_DATA,
  payload: response,
});

export const request = (params: RequestParams, meta: RequestCallbacks): StartRequestAction => ({
  type: START_REQUEST,
  payload: params,
  meta,
});
